import React, {useCallback, useEffect, useRef, useState} from 'react';

import '../css/reset.css';
import './_Index.scss';
//import styles from './_Index.style';

import {
    Form as NForm,
    Popover,
    Button,
    Modal,
    message,
    Upload,
    Input,
    Space,
    Select,
    Radio,
    DatePicker,
    InputNumber,
    Menu,
    Dropdown
} from 'antd';

import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import {StaticEvent} from "../_/StaticEvent";
import _ from "../_";

import {Link} from 'react-router-dom';

import {
    useParams,
    useNavigate
} from "react-router-dom";
import {PageDataManager} from "../hooks/UsePageDataManager";

import {Field, Form} from "react-final-form";
import {SessionManager} from "../hooks/UseSessionManager";
import {NavigateFunction} from "react-router";

import {
    LoadingOutlined, LockOutlined, PlusOutlined, DownOutlined,
    EllipsisOutlined, GlobalOutlined, PhoneOutlined, SmileFilled, FileImageFilled
} from "@ant-design/icons";
import {lastValueFrom} from "rxjs";
import UseLoadingManager from "../hooks/UseLoadingManager";

import Partial_Appointment__Modal_Preview from "./Partial_Appointment__Modal_Preview";
import Partial_Modal_Photogallery from "./Partial_Modal_Photogallery";
import Partial_Appointment__Modal_EditOrAddRegister from "./Partial_Appointment__Modal_EditOrAddRegister";
import Pg_MedicalRecord from "./Pg_MedicalRecord";
import Partial_CommonCard from "./Partial_CommonCard";
import UseCompState from "../hooks/UseCompState";

var moment = require('moment');
const {Option} = Select;


type ViewModelProps = {
    refModal: any,
};
type Props = {
    PrefixTarget?: string;
    pageDataManager: PageDataManager
    sessionManager: SessionManager,
    navigate: NavigateFunction,
    parentState?: any;

    viewModel: ViewModelProps,
};
const dateFormat = 'YYYY/MM/DD';

export default function Partial_Waitingroom__Tab_ServingList(props: Props) {
    let PrefixTarget: string = props.PrefixTarget || 'Partial_Waitingroom__Tab_ServingList';
    let pageDataManager: PageDataManager = props.pageDataManager;
    let sessionManager: SessionManager = props.sessionManager;
    let navigate: NavigateFunction = props.navigate;

    const viewModel = props.viewModel;

    //#region ForceRender Control
    const [, setForceRender] = useState(false);
    const forceRender = () => {
        setForceRender(s => !s);
    };
    //#endregion

    const loadingManager = UseLoadingManager({shouldReRenderOnLoading: false});

    //#region :State CompState
    const state = UseCompState({parentState: props.parentState});

    if (!state.hasInit) {
        state.hasInit = true;
    }
    //#endregion

    //#region Boot
    let _refDoLoadPartialData: any = useRef<{ alwaysLoad?: boolean }>(null);
    useEffect(() => {
        const _loadPartialData = async (): Promise<void> => {
            let hide = message.loading({
                type: 'loading',
                class: 'myMessage',
                content: <div className="myMessageBody">搜尋中...</div>,
                key: 'loading',
                duration: 0
            });

            // VALIDATE INPUT
            //const id : any = this.props.match.params.id;
            // const id = 1;
            // if (!id) {
            //     return; //ERROR INPUTS
            // }

            // WAITING SCREEN
            loadingManager.changeLoadingCount(+1);
            //StaticEvent.LoadingEvent.next(true);

            // POST
            let postData = {
                //p1: 1,
                s: state.s,
                q: state.q,
                timezoneOffset: (new Date()).getTimezoneOffset() * 60 * 1000,
            };
            const postUrl = ApiService.urlMapping('~/pet_api/1/partial_waitingroom/pane_servinglist');
            const post$ = Static.apiService.post(postUrl, postData);
            post$.subscribe(async (res: any) => {
                    hide();

                    // CLOSE WAITING SCREEN
                    loadingManager.changeLoadingCount(-1);
                    //StaticEvent.LoadingEvent.next(false);

                    let data = res.data;
                    let error = data.error || null;
                    let result = error == null;

                    if (result) { // SUCEESS
                        let payload = data.payload;
                        _._debug.warn(payload);

                        pageDataManager.emptyZone(PrefixTarget);
                        let changeShard = {
                            [PrefixTarget]: {
                                ...payload,
                            }
                        }
                        pageDataManager.merge(changeShard);
                        pageDataManager.apply();
                        forceRender();
                    } else {
                        // AUTH USER EXPIRED T:1
                        if (error.code == 2) {
                            await sessionManager.setLogout();
                            Static.NavAwayToLogin(pageDataManager, navigate)(null);
                            return;
                        }

                        _._debug.error(error);
                        alert(error.message);
                    }
                }, async (err) => {
                    // CLOSE WAITING SCREEN
                    loadingManager.changeLoadingCount(-1);
                    //StaticEvent.LoadingEvent.next(false);
                    _._debug.warn(err);
                    alert('網路連線有問題');
                }
            );
            return lastValueFrom(
                post$
            );
        }

        const doLoadPartialData = async ({alwaysLoad = false}): Promise<void> => {
            // do not dynamically load data if condition fits.
            if (!alwaysLoad) {
                if (pageDataManager.isZoneExist(PrefixTarget)) {
                    return;
                }
            }

            await _loadPartialData();
        }

        _refDoLoadPartialData.current = doLoadPartialData;
        _refDoLoadPartialData.current({});
    }, [pageDataManager.get(PrefixTarget)]);
    //#endregion


    const Body = () => {
        const List_掛號 = pageDataManager.get(`${PrefixTarget}.List_掛號`);
        const List_醫生 = pageDataManager.get(`${PrefixTarget}.List_醫生`);

        let Data_掛號 = List_掛號;
        if (Data_掛號) {
            let serialCounter = 0;
            Data_掛號 = Data_掛號.map((r) => {
                serialCounter += 1;
                return {
                    ...r,
                    key: r.掛號Id,
                    serial: serialCounter,
                    // 主人姓名: r.主人姓名,
                    // 身分證: r.身分證,
                    // 手機: r.手機,
                    // 聯絡電話: r.聯絡電話,
                    // data: r,
                }
            });
        }

        return (
            <Partial_CommonCard
                PrefixTarget={'Partial_CommonCard'}
                pageDataManager={pageDataManager}
                sessionManager={sessionManager}
                navigate={navigate}
                parentState={state}

                viewModel={{
                    refModal: null,
                    Data_掛號: Data_掛號,
                    List_醫生: List_醫生,
                    isLoading: Data_掛號 === null,

                    Kind: 'Kind_ServingList',

                    OnDid: () => {
                        pageDataManager.clear();
                        pageDataManager.reloadAsync({alwaysLoad: true});
                        //state.parentState?._refDoLoadPartialData?.current?.({alwaysLoad: true});
                    }
                }}
            />
        );
    }

    //#region Render
    return <React.Fragment>
        {Body()}
    </React.Fragment>;
    //#endregion
}
Partial_Waitingroom__Tab_ServingList.displayName = 'Partial_Waitingroom__Tab_ServingList';

